<template>
  

  <div class="bg-brown" id="intro_sequence">
    <div v-if="items" class="min-vh-100">
        <Question 
          aria-hidden="true" 
          v-for="(i, index) in items" 
          :key="i.id" 
          :item="i" 
          :index="index" 
          :num_items="items.length">
        </Question>

        <h1 class="sr-only" v-html="$t(iKey('intro_question', 'question', 'text'))"></h1>
        <ul class="sr-only">
          <li v-for="item in items" :key="item.id" >
            {{ $t(iKey('related_intro_steps', item, 'copy')) }}
          </li>
        </ul>
    </div>
  </div>
  
  
</template>

<script>
import Question from '@/components/intro/Question.vue'

export default {
  name: 'Intro',
  props: [
    'items',
  ],
  components: {
    Question
  },
  mounted(){
    var dur = ((this.windowHeight * (this.items.length - 1)  * 2))

    const scene_1 = this.$scrollmagic.scene({
        triggerElement: '#intro_sequence',
        triggerHook: 0,
        duration: dur,
        reverse: true
    })
    this.$scrollmagic.addScene(
      scene_1
        .setPin('#intro_sequence')
        //.addIndicators()
    )  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-brown{
    background-color: #382e2b;
    color: white;
}
</style>
